<template>
  <div>
    <div class="flex items-center px-4" :class="singleSelector ? 'h-16 border-b border-solid border-light-grey-600' : 'h-13'" v-for="i in rows" :key="i">
      <div class="flex flex-col flex-grow">
        <skeleton-loader has-random-width />
        <skeleton-loader v-if="singleSelector" class="mb-0" width="50px" />
      </div>
      <skeleton-loader v-if="singleSelector" class="mb-0 mx-4" width="60px" />
      <skeleton-loader v-if="!singleSelector" class="mb-0 ml-4" width="16px" />
      <skeleton-loader class="mb-0 ml-6" :class="[{ 'sm:ml-12': singleSelector }]" width="16px" />
    </div>
  </div>
</template>

<script>
import { SkeletonLoader } from '@/components/ContentLoader/components'

export default {
  name: 'ContextLayout',

  components: {
    SkeletonLoader
  },

  props: {
    rows: {
      type: Number,
      default: 11
    },
    singleSelector: {
      type: Boolean,
      default: false
    }
  }
}
</script>
